<template>
  <div>
    <AchievementsHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">成果需求</a-breadcrumb-item>
        <a-breadcrumb-item>技术需求详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="tankName">{{ detail.name }}</div>
      <div class="infoBox">
        <a-descriptions :column="3">
          <a-descriptions-item label="所属高新技术领域">
            <dict-render :dict-obj="dictObjs['belong_techField']" v-if="detail.highTechField"
              :text="detail.highTechField"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="需求类型">
            <dict-render :dict-obj="dictObjs['demand_type']" v-if="detail.trType"
              :text="detail.trType"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="研究经费(万元)">{{ detail.researchFunding }}</a-descriptions-item>
          <!-- <a-descriptions-item label="项目阶段">
            <dict-render :dict-obj="dictObjs['projectStage']" v-if="detail.projectPhase"
              :text="detail.projectPhase"></dict-render>
          </a-descriptions-item> -->
          <!-- <a-descriptions-item label="需求优先级">
            <dict-render :dict-obj="dictObjs['demand_priority']" v-if="detail.priority"
              :text="detail.priority"></dict-render>
          </a-descriptions-item> -->
        </a-descriptions>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            需求描述
          </div>
        </div>
        <div class="talentContentBox">
          {{ detail.description }}
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { tableListMixin, dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import { achievementFontInfo } from "@/api/achievementsService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: "noticeDetail",
  components: { AchievementsHeader, DictRender, LayoutFooter },
  mixins: [tableListMixin, dictMixin],
  data() {
    return {
      dictNames: 'belong_techField,demand_type,projectStage,demand_priority',
      companyJobList: {},
      detail: {},
      ellipsis: true,
      isUserCode: false
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: achievementFontInfo.demandDetail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.detail = res
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/achievements/components/achievementRequirements",
        query: { type: '成果需求',tab: '2' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/achievements/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
  },
  mounted() {
    this.getDetail()
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  // background: white;
}

.tutorBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .tankName {
    margin-bottom: 18px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .infoBox {
    position: relative;
    padding: 20px;
    background-color: #ecf0f6;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;

    .grayBox {
      position: absolute;
      right: 5%;
      bottom: 30%;
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;
  background-color: #fff;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }
    }

    .talentContentBox {
      padding: 14px 20px;
      width: 100%;
      text-indent: 2em;
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #333;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #333;
}
</style>
